exports.IDS = {
  // IMG_URL: "http://127.0.0.1:4427",
  IMG_URL: "https://afmobility.node.profcymadev.com:4427",
  // IMG_URL: "https://node.afiway.com:4427",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  users: {
    admin: 1,
    builder: 2,
    customer: 3,
  },

  usersrole: {
    admin: "Admin",
    builder: "Builder",
    customer: "Customer",
  },

  legal_verification_status: {
    process: 1,
    approved: 2,
    rejected: 3,
  },

  Permission: {
    Roles: { List: 1, Add: 2, Edit: 3, Delete: 4 },
    Users: { List: 5, Add: 6, Edit: 7, Delete: 8 },
    Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
    State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
    City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
    Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },
    University: { List: 25, Add: 26, Edit: 27, Delete: 28 },
    Social_Link: { List: 29, Add: 30, Edit: 31, Delete: 32 },
    Testimonial: { List: 33, Add: 34, Edit: 35, Delete: 36 },
    Faq: { List: 37, Add: 38, Edit: 39, Delete: 40 },
    Whychooseus: { List: 41, Add: 42, Edit: 43, Delete: 44 },
    Oursupport: { List: 45, Add: 46, Edit: 47, Delete: 48 },
    Contact_us: { List: 49 },
    Program_Highlight: { List: 50, Add: 51, Edit: 52, Delete: 53 },
    Eligibility_Requirement: { List: 54, Add: 55, Edit: 56, Delete: 57 },
    Career_Requirement: { List: 58, Add: 59, Edit: 60, Delete: 61 },
    Requirement_Documents: { List: 62, Add: 63, Edit: 64, Delete: 65 },
    Document: { List: 66, Add: 67, Edit: 68, Delete: 69 },
    Requirement: { List: 70, Add: 71, Edit: 72, Delete: 73 },
    CollegeDashboard: { List: 74 },
    CollegeIntern: { List: 75 },
    CollegeOffer: { List: 76 },
    CollegeDocuments: { List: 77 },
    CollegeProfile: { List: 78 },
    HotelDashboard: { List: 79 },
    HotelIntern: { List: 80 },
    HotelDocuments: { List: 81 },
    HotelProfile: { List: 82 },
    StudentDashboard: { List: 83 },
    StudentApplications: { List: 84 },
    StudentDocuments: { List: 85 },
    StudentBilling: { List: 86 },
    StudentSupport: { List: 87 },
    StudentProfile: { List: 88 },
    Course: { List: 89, Add: 90, Edit: 91, Delete: 92 },
    Accomodation: { List: 93, Add: 94, Edit: 95, Delete: 96 },
    Study_Program: { List: 97, Add: 98, Edit: 99, Delete: 100 },
    Internship: { List: 101, Add: 102, Edit: 103, Delete: 104 },
    Ticket: { List: 105, Add: 106, Edit: 107 },
    StudentList: { List: 108 },
    CollegeList: { List: 109 },
    HotelList: { List: 110 },
    StudentDocument: { List: 111, Add: 112, Edit: 113, Delete: 114 },
    addStudentDocument: { List: 115, Add: 116, Edit: 117, Delete: 118 },
    AdminDashboard: { List: 119 },

    WebsiteHomeWhychooseUS: { List: 120 },
    WebsiteHomeWhoWeAre: { List: 121 },
    WebsiteHomeSuccessSpeaks: { List: 122 },
    WebsiteHomeFAQ: { List: 123 },

    WebsiteAboutUsOurStory: { List: 124 },
    WebsiteAboutUsOurProcess: { List: 125 },

    WebsiteContactUsGetInTouch: { List: 126 },
  },
};
